import { WarrantI18N } from './warrant-i18n.entity';
import { Warrant } from './warrant.entity';

export const WarrantCodeValue = [
    'AU1000', 'AU1001', 'AU1002', 'AU1003', 'AU1004',
    'AU1005', 'AU1006', 'AU1007', 'AU1008', 'AU1009',
    'AU1010', 'AU1011', 'AU1012', 'AU1013', 'AU1020',
    'AU1021', 'AU1022', 'AU1023', 'AU1024', 'AU1025',
    'AU1026', 'AU1027', 'AU1028', 'AU1029', 'AU1030'
];

/**
 * 授权集合
 */
export const WarrantCollectionValue = [
    'AUC1000', 'AUC1001', 'AUC1002'
];

/**
 * 项目标识
 */
export const ProjectValue = [
    // D 项目
    'SW2P5'
];

export declare type ProjectCode =
    // D 项目
    'SW2P5';
/**
 * 授权集合
 * Warrant Collection code
 */
export declare type WarrantCollectionCode =
    // 标准版
    'AUC1000' |
    // 专业版
    'AUC1001' |
    // 企业版
    'AUC1002';

/**
 * 授权点
 * Warrant code
 */
export declare type WarrantCode =
    // 基础功能(BASIC_FUNCTION)
    'AU1000' |
    // 对接2.0项目功能（SW_OCEAN_2P0_APPS）
    'AU1001' |
    // Smartway Cloud云报表
    'AU1002' |
    // POS收银端
    'AU1003' |
    // RWA服务员点餐
    'AU1004' |
    // COP平板点餐
    'AU1005' |
    // MOP大屏点餐
    'AU1006' |
    // QOP扫码点餐
    'AU1007' |
    // QOP Lite
    'AU1008' |
    // KWA智能后厨
    'AU1009' |
    // DB服务器Pro
    'AU1010' |
    // DB服务器Enterprise
    'AU1011' |
    // 售后服务年套餐
    'AU1012' |
    // Aruba 电子发票服务
    'AU1013' |
    // Deliverect平台功能
    'AU1020' |
    // JK POS 管理老客户的授权日期管理
    'AU1021' |
    // DataBubble
    'AU1022' |
    // Ecco POS
    'AU1023' |
    // QOP WAN
    'AU1024' |
    // QOP WAN Micro
    'AU1025' |
    // QOP WAN Enterprise
    'AU1026' |
    // Qodeup付款
    'AU1027' |
    // Fiskaly TSS 集成
    'AU1028' |
    // ECCO-EFR
    'AU1029' |
    // AI运营助手
    'AU1030';
    

/**
 * 校验点
 * LimitRule Type
 */
export declare type LimitRuleType =
    // 日期校验
    'AUP1001' |
    // 数量校验
    'AUP1002' |
    // 最大数量校验
    'AUP1003' |
    // WS 最大数量校验
    'AUP1004' |
    // 日期和数量校验
    'AUP1005' |
    // 日期和最大数量校验
    'AUP1006' |
    // 日期和 WS 最大数量校验
    'AUP1007';

export declare type LimitRule<T = DateLimitRule | CountLimitRule |
    NumMaxLimitRule | WebsocketMaxConnectionsLimitRule | DateCountLimitRule |
    DateNumMaxLimitRule | DateWebsocketMaxConnctionsLimitRule> = T & {
        name?: string;
        code?: string;
        start_date?: Date;
        end_date?: Date;
        max_num?: number;
        remaining_num?: number;
        total_num?: number;
    };

export enum LimitRuleTypeEnum {
    // 日期校验
    DATE_LIMIT_RULE = 'AUP1001',
    // 数量校验
    COUNT_LIMIT_RULE = 'AUP1002',
    // 最大数量校验
    NUM_MAX_LIMIT_RULE = 'AUP1003',
    // WS 最大数量校验
    WEBSOCKET_MAX_CONNECTIONS_LIMIT_RULE = 'AUP1004',
    // 日期和数量校验
    DATE_COUNT_LIMIT_RULE = 'AUP1005',
    // 日期和最大数量校验
    DATE_NUM_MAX_LIMIT_RULE = 'AUP1006',
    // 日期和 WS 最大数量校验
    DATE_WEBSOCKET_MAX_CONNECTIONS_LIMIT_RULE = 'AUP1007'
}

/**
 * 日期校验
 * 总价计价对象:Dcoin × 天数
 */
export declare type DateLimitRule = {
    code?: LimitRuleTypeEnum.DATE_LIMIT_RULE,
    start_date?: Date,
    end_date?: Date,
    days?: number,
    coin_per_day?: number
};

/**
 * 数量校验
 * 总价计价对象:Ncoin × 个数
 */
export declare type CountLimitRule = {
    code?: LimitRuleTypeEnum.COUNT_LIMIT_RULE,
    remaining_num?: number,
    total_num?: number,
    coin_per_num?: number
};

/**
 * 最大数量校验
 * 总价计价对象:Ncoin × 个数
 */
export declare type NumMaxLimitRule = {
    code?: LimitRuleTypeEnum.NUM_MAX_LIMIT_RULE,
    max_num?: number,
    coin_per_num?: number
};

/**
 * WS 最大数量校验
 * 总价计价对象:Ncoin × 个数
 */
export declare type WebsocketMaxConnectionsLimitRule = {
    code?: LimitRuleTypeEnum.WEBSOCKET_MAX_CONNECTIONS_LIMIT_RULE,
    max_num?: number,
    coin_per_num?: number
};

/**
 * 日期和数量校验
 * 总价计价对象: (Dcoin × 天数 ) + ( Ncoin × 个数 )
 */
export declare type DateCountLimitRule = {
    code?: LimitRuleTypeEnum.DATE_COUNT_LIMIT_RULE,
    start_date?: Date,
    end_date?: Date,
    days?: number,
    remaining_num?: number,
    total_num?: number,
    coin_per_day?: number,
    coin_per_num?: number
};

/**
 * 日期和最大数量校验
 * 总价计价对象:  ( Dcoin × 天数 ) × ( Ncoin × 个数 )
 */
export declare type DateNumMaxLimitRule = {
    code?: LimitRuleTypeEnum.DATE_NUM_MAX_LIMIT_RULE,
    start_date?: Date;
    end_date?: Date;
    days?: number,
    max_num?: number,
    coin_per_day?: number,
    coin_per_num?: number,
};

/**
 *  日期和 WS 最大数量校验
 * 总价计价对象: ( Dcoin × 天数 ) × ( Ncoin × 个数 )
 */
export declare type DateWebsocketMaxConnctionsLimitRule = {
    code?: LimitRuleTypeEnum.DATE_WEBSOCKET_MAX_CONNECTIONS_LIMIT_RULE,
    start_date?: Date;
    end_date?: Date;
    days?: number,
    max_num?: number,
    coin_per_day?: number,
    coin_per_num?: number,
};

export const WarrantExamples: Array<{
    project: ProjectCode,
    code: WarrantCode,
    limit_point: Partial<LimitRule>
}> = [
        {
            project: 'SW2P5',
            code: 'AU1000',
            limit_point: {
                name: 'AUP1001',
                code: LimitRuleTypeEnum.DATE_LIMIT_RULE
            }
        },
        {
            project: 'SW2P5',
            code: 'AU1001',
            limit_point: {
                name: 'AUP1001',
                code: LimitRuleTypeEnum.DATE_LIMIT_RULE
            }
        }
    ];

export declare type WarrantSortKeyByType = Array<{
    code?: WarrantCode, warrants?: Array<Warrant>, limit_point_code?: string,
    total_num?: number, remaining_num?: number, end_date?: string,
    start_date?: string, warranti18N?: WarrantI18N
}>;

export declare type WarrantCollection = Array<{
    code: WarrantCollectionCode,
    warrants: Array<Warrant>
}>;

export const WarrantCollectionExamples: Array<{
    code: WarrantCollectionCode,
    warrants: Array<{
        project: ProjectCode,
        code: WarrantCode,
        limit_point: Partial<LimitRule>
    }>
}> = [
        {
            code: 'AUC1000',
            warrants: [
                {
                    project: 'SW2P5',
                    code: 'AU1000',
                    limit_point: {
                        name: 'AUP1001',
                        code: LimitRuleTypeEnum.DATE_LIMIT_RULE
                    }
                }
            ]
        },
        {
            code: 'AUC1001',
            warrants: [
                {
                    project: 'SW2P5',
                    code: 'AU1000',
                    limit_point: {
                        name: 'AUP1001',
                        code: LimitRuleTypeEnum.DATE_LIMIT_RULE
                    }
                }
            ]
        },
        {
            code: 'AUC1002',
            warrants: [
                {
                    project: 'SW2P5',
                    code: 'AU1000',
                    limit_point: {
                        name: 'AUP1001',
                        code: LimitRuleTypeEnum.DATE_LIMIT_RULE
                    }
                }
            ]
        }
    ];
